export default __webpack_public_path__ + "static/media/bg2.6f6acc23.png";